export default "__VITE_ASSET__j1UaaG23FXgRuzf$hfavtg__"